import { render } from "./AddBin.vue?vue&type=template&id=077e45ce&scoped=true"
import script from "./AddBin.vue?vue&type=script&lang=js"
export * from "./AddBin.vue?vue&type=script&lang=js"

import "./AddBin.vue?vue&type=style&index=0&id=077e45ce&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077e45ce"]])

export default __exports__